import { gbConstants } from "../_constants";
import { USER_TYPE } from "../_constants";

export const userService = {
    login,
    logout,
    register,
    campaignSigned
};

const loginURL = `${gbConstants.HOST_SERVICE}/v1.1/login`;
const registerURL = `${gbConstants.HOST_SERVICE}/v1.1/register`;

function login(email, password) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            email: email,
            password: password,
            type: USER_TYPE.ADVERTISER
        })
    };

    return fetch(loginURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(user => {
            if (user.error && user.error.code !== 200) {
                return Promise.reject(user.error);
            }
            // login successful if there's a jwt token in the response
            if (user.data && user.data.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem("user", JSON.stringify(user.data));
            }
            return user.data;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("user");
}

function register(user) {
    user.type = USER_TYPE.ADVERTISER;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            name: user.name,
            email: user.email,
            password: user.password,
            phoneNumber: user.phoneNumber,
            type: user.type
        })
    };

    return fetch(registerURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(user => {
            if (user.error && user.error.code !== 200) {
                return Promise.reject(user.error);
            }
            return user.data;
        });
}

function campaignSigned(campaignId) {
    // remove user from local storage to log user out
    var user = JSON.parse(localStorage.user);
    user.campaignSigned = campaignId;
    localStorage.setItem("user", JSON.stringify(user));
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js